// Cosmétiques achetables dans la Boutique Externe du menu principal.
// Devise = or total cumulé gagné en jeu (meta.totalGold) — séparé de l'or de la run en cours.

export const BORDERS = [
  {
    id: "default",
    name: "Sans bordure",
    description: "L'apparence par défaut.",
    price: 0,
    rarity: "common",
    // CSS applied around the profile avatar
    style: { className: "border-4 border-slate-950", ring: "" },
  },
  {
    id: "iron",
    name: "Fer brut",
    description: "Classique, indestructible.",
    price: 100,
    rarity: "common",
    style: { className: "border-4 border-slate-300", ring: "ring-2 ring-slate-500" },
  },
  {
    id: "bronze",
    name: "Cercle de bronze",
    description: "L'éclat des premiers vainqueurs.",
    price: 250,
    rarity: "common",
    style: { className: "border-4 border-amber-700", ring: "ring-2 ring-amber-500" },
  },
  {
    id: "emerald_vines",
    name: "Lianes émeraude",
    description: "Une nature qui s'enroule autour de toi.",
    price: 500,
    rarity: "uncommon",
    style: { className: "border-4 border-emerald-400", ring: "ring-4 ring-emerald-700/50" },
  },
  {
    id: "frozen",
    name: "Givre éternel",
    description: "Le froid t'a marqué.",
    price: 750,
    rarity: "uncommon",
    style: { className: "border-4 border-cyan-300", ring: "ring-4 ring-cyan-500/40" },
  },
  {
    id: "shadow",
    name: "Voile d'ombre",
    description: "On distingue à peine ton avatar.",
    price: 1200,
    rarity: "rare",
    style: { className: "border-4 border-purple-700", ring: "ring-4 ring-purple-400/50" },
  },
  {
    id: "ember",
    name: "Aura de braise",
    description: "Une lueur qui crépite doucement.",
    price: 1800,
    rarity: "rare",
    style: { className: "border-4 border-orange-500 cosmetic-pulse-warm", ring: "ring-4 ring-orange-300/40" },
  },
  {
    id: "sky_halo",
    name: "Halo céleste",
    description: "Un rayon divin t'entoure.",
    price: 2500,
    rarity: "rare",
    style: { className: "border-4 border-sky-300", ring: "ring-4 ring-sky-100/60" },
  },
  {
    id: "royal_gold",
    name: "Cadre royal",
    description: "On t'a vu vaincre des boss.",
    price: 4000,
    rarity: "epic",
    style: { className: "border-4 border-yellow-400 cosmetic-pulse-gold", ring: "ring-4 ring-yellow-200/60" },
  },
  {
    id: "rainbow_prism",
    name: "Prisme arc-en-ciel",
    description: "Reflète ta personnalité unique.",
    price: 6000,
    rarity: "epic",
    style: { className: "cosmetic-rainbow-border", ring: "" },
  },
  {
    id: "void_crown",
    name: "Couronne du Vide",
    description: "Seuls les vétérans peuvent la porter.",
    price: 10000,
    rarity: "legendary",
    style: { className: "border-4 border-fuchsia-500 cosmetic-pulse-arcane", ring: "ring-4 ring-fuchsia-300/50" },
  },
];

export const BORDERS_BY_ID = Object.fromEntries(BORDERS.map((b) => [b.id, b]));

// === BANNERS (background of the profile hero card) ===
export const BANNERS = [
  { id: "default",        name: "Sans bannière",       price: 0,    rarity: "common",    css: "bg-slate-800" },
  { id: "sunset_ridge",   name: "Crête au coucher",    price: 200,  rarity: "common",    css: "bg-gradient-to-br from-orange-400 via-rose-500 to-purple-600" },
  { id: "forest_canopy",  name: "Canopée forestière",  price: 350,  rarity: "common",    css: "bg-gradient-to-br from-emerald-700 via-green-800 to-emerald-950" },
  { id: "deep_sea",       name: "Profondeurs marines", price: 600,  rarity: "uncommon",  css: "bg-gradient-to-br from-blue-900 via-cyan-800 to-blue-950" },
  { id: "lava_flow",      name: "Coulée de lave",      price: 900,  rarity: "uncommon",  css: "bg-gradient-to-br from-orange-600 via-red-700 to-rose-900" },
  { id: "frost_palace",   name: "Palais de givre",     price: 1500, rarity: "rare",      css: "bg-gradient-to-br from-cyan-200 via-sky-400 to-indigo-700" },
  { id: "void_temple",    name: "Temple du Vide",      price: 2200, rarity: "rare",      css: "bg-gradient-to-br from-purple-900 via-slate-900 to-fuchsia-950" },
  { id: "celestial_aura", name: "Aura céleste",        price: 3500, rarity: "epic",      css: "bg-gradient-to-br from-yellow-300 via-amber-400 to-rose-500" },
  { id: "galaxy_rift",    name: "Faille galactique",   price: 5000, rarity: "epic",      css: "bg-gradient-to-br from-indigo-900 via-fuchsia-700 to-purple-900" },
  { id: "champion_throne",name: "Trône du Champion",   price: 8000, rarity: "legendary", css: "bg-gradient-to-br from-yellow-400 via-amber-500 via-orange-500 to-red-700 cosmetic-pulse-gold" },
];

export const BANNERS_BY_ID = Object.fromEntries(BANNERS.map((b) => [b.id, b]));

export const COSMETIC_RARITY_COLORS = {
  common:    "text-slate-300",
  uncommon:  "text-emerald-300",
  rare:      "text-sky-300",
  epic:      "text-fuchsia-300",
  legendary: "text-amber-300",
};
